import { Fragment, ReactNode, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { getAllPublishedNews } from "../../API/News/newsService";
import "../../style/CardSlide.css";
import "../../style/carousel.css";
import HomeCard from "../Cards/HomeCard";
import { Button } from "../ui/button";
import {
  Carousel,
  CarouselActionButton,
  CarouselContent,
  CarouselItem,
  CarouselNext,
  CarouselPrevious,
} from "../ui/carousel";

type Props = {
  children?: ReactNode;
};

const NewsHomeSection = ({ children }: Props) => {
  const [news, setNews] = useState<any[]>([]);

  const fetchData = async () => {
    try {
      const response = await getAllPublishedNews();
      setNews(response?.news || []);
    } catch (error) {
      console.error("Error fetching news:", error);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <Fragment>
      <div className="p-1 md:p-24" style={{ zIndex: 0 }}>
        <div className="text-3xl font-bold text-center text-black">
          Actualités récentes  
        </div>
        <div className="container">
          <Carousel
            opts={{ align: "start", loop: true }}
            className="w-full mt-20 rounded-lg"
          >
            <CarouselContent>
              {news.map((item) => (
                <CarouselItem key={item.id} className="basis-auto">
                  <HomeCard news={item} />
                </CarouselItem>
              ))}
            </CarouselContent>
            <div className="flex justify-between mt-10 mr-10">
              <div className="items-center"></div>
              {/* Spacer to push content to the right */}
              <div className="flex justify-center">
                <CarouselActionButton
                  title="Toutes les actualités"
                  navigateLink="/actualités"
                  className="mx-auto"
                />
              </div>
              <div className="flex gap-1">
                <CarouselPrevious
                  inlineStyle={true}
                  className="relative text-white rounded-lg hover:bg-secondary bg-neutral-100 hover:text-white bg-primary"
                />
                <CarouselNext
                  inlineStyle={true}
                  className="relative text-white rounded-lg hover:bg-secondary bg-neutral-100 hover:text-white bg-primary"
                />
              </div>
            </div>
          </Carousel>
        </div>
      </div>
    </Fragment>
  );
};

export default NewsHomeSection;
